module.exports = __WEBPACK_EXTERNAL_MODULE_70__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 70
// module chunks = 0